// Helpers
import colors from 'vuetify/es5/util/colors'

export default {
    light: {
        primary: '#25335a',
        secondary: '#0f74bb',
        third: '#24ab80',
        tertiary: '#495057',
        accent: '#82B1FF',
        error: '#f55a4e',
        info: '#00d3ee',
        success: '#5cb860',
        warning: colors.red.base,
        content: colors.shades.white
    },
    dark: {
        primary: '#25335a',
        secondary: '#0f74bb',
        third: '#24ab80',
        tertiary: '#495057',
        accent: '#82B1FF',
        error: '#f55a4e',
        info: '#00d3ee',
        success: '#5cb860',
        warning: colors.red.base,
        content: colors.shades.white
    }
}
